/** @format */

require('./bootstrap');
import appSettings from './appSettings';

// Core
import Vue from 'vue';

// Global plugins
import CsVendorsPlugin from '@/js/plugins/cs-vendors';
import CsHelpersPlugin from '@/js/plugins/cs-helpers';
import CsKeyboardPlugin from '@/js/plugins/cs-keyboard';
import CsTranslationPlugin from '@/js/plugins/cs-translation';
Vue.use(CsVendorsPlugin);
Vue.use(CsHelpersPlugin);
Vue.use(CsKeyboardPlugin);
Vue.use(CsTranslationPlugin);

// Axios
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Vue router
import router from './router';

const breakpoints = {  
	xs: 576,
	sm: 768,
	md: 992,
	lg: 1200,
	xl: 1440,
	xxl: Infinity
}

// Vue Media Query
import VueMq from 'vue-mq';
Vue.use(VueMq, {
	breakpoints: breakpoints,
	defaultBreakpoint: 'sm'
});

// Localization
import {$csI18n} from './modules/csI18n';

// WYSIWYG editor
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala);

// Font Awesome, moved to a file to help with testing
import CsFontAwesomeIcon from '@/js/plugins/cs-font-awesome-icon';
Vue.use(CsFontAwesomeIcon);

import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('Mgo+DSMBMAY9C3t2VVhjQlFac1ZJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0diXH5WcHBVRGheUUM=');

// Main app component
import CsApp from './global/cs-app.vue';

appSettings
	.get()
	.then((csSettings) => { 
		new Vue({
			router,
			i18n: $csI18n,
			data() {
				return {
					locales: [],
					config: {
						apiProtocol: csSettings.VUE_APP_API_PROTOCOL,
						apiDomain: csSettings.VUE_APP_API_DOMAIN,
						apiVersion: csSettings.VUE_APP_API_VERSION,
						identityBase: csSettings.VUE_APP_IDENTITY_BASE,
						debugMode: csSettings.VUE_APP_DEBUG_MODE,
						isMultiLingual: csSettings.VUE_APP_MULTILINGUAL,
						activityThreshold: csSettings.VUE_APP_ACTIVITY_TRESHOLD,
						maxSessionLength: csSettings.VUE_APP_MAX_SESSION_LENGTH
					},
					platformInstanceSettings: {
						dateDisplayFormat: 'Do MMM, Y',
						timeDisplayFormat: 'HH:mm:ss',
						sessionDiagnosticsEnabled: true,
						fileStorageSettings: {
							maxFormPayload: 50
						}
					},
					csVersion: "2.1.0",
					activeEntity: {},
					activeScreen: {},
					currentFormIsDirty: false,
					errors: [],
					configModeEnabled: false
				};
			},

			render: (h) => h(CsApp)
		}).$mount('#app');
	})
	.catch(() => {
		console.error('Failed to load app settings, please make sure the settings file exists');
	});
